export const shiftAssignApi = {
    heading:[

        {
            head:"Emp ID"
        },
        {
            head:"Employee Name"
        },
        {
            head:"Designation"
        },
        {
            head:"Active Shifts"
        },       
        {
            head:"Action"
        },
    ],
    data:[
       {
        tickmark:false,
        empid:1138,
        empname:"Shaheda Iqbal",
        designation:"Admin Officer",
        activeshifts:"All Office",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        tickmark:false,
        empid:1139,
        empname:"Shaheda Iqbal",
        designation:"Admin Officer",
        activeshifts:"All Office",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        tickmark:false,
        empid:1140,
        empname:"Shaheda Iqbal",
        designation:"Admin Officer",
        activeshifts:"All Office",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       
     
       
    ]
}